/**
 * KeyTile - Collectible key (parameterized by color)
 * Single class handles all 4 key colors
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export type KeyColor = "green" | "red" | "orange" | "blue";

export class KeyTile extends BaseTile {
  private color: KeyColor;

  constructor({
    col,
    row,
    color,
    id,
  }: {
    col: number;
    row: number;
    color: KeyColor;
    id?: string;
  }) {
    super(id ?? `key-${color}-${col}-${row}`, col, row);
    this.color = color;
  }

  tileType(): TileIndex {
    switch (this.color) {
      case "green":
        return TILE.KEY_GREEN;
      case "red":
        return TILE.KEY_RED;
      case "orange":
        return TILE.KEY_ORANGE;
      case "blue":
        return TILE.KEY_BLUE;
    }
  }

  textureDescriptor(): TextureDescriptor {
    // Orange key is stored as yellow-key.png in the assets
    const fileName = this.color === "orange" ? "yellow" : this.color;
    return {
      type: "png",
      path: `tiles/${fileName}-key.png`,
    };
  }

  getColor(): KeyColor {
    return this.color;
  }

  clone(): KeyTile {
    const copy = new KeyTile({
      col: this.col,
      row: this.row,
      color: this.color,
      id: this.id,
    });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return {
      type: "key",
      color: this.color,
      id: this.id,
      col: this.col,
      row: this.row,
    };
  }
}
